var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "id_svgCanvas",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5772181599_SVGID_1__focus",
    d: "M33.729,53H23.005l-0.002-16.395c0,0,2.397,2.77,7.48,2.77c5.773,0,7.598-1.261,7.598-1.261v-2.663    c-1.463,1.105-3.281,1.628-5.718,1.628C29.228,37.079,27,35.125,27,32c0-3.115,2.228-5.082,5.363-5.082    c2.437,0,4.255,0.52,5.718,1.625v-2.647c0,0-1.889-1.289-7.598-1.289c-5.085,0-7.483,2.773-7.483,2.773l0.005-9.997    c0-3.52,2.813-6.385,6.268-6.385H40v36.689C40,50.094,37.199,53,33.729,53z M14.73,53H4V38.334c0,0,3.085,1.205,6.625,1.205    c4.697,0,8.375-1.122,8.375-5.789V25h-5v8.167c0,2.307-0.917,3.954-4.476,3.954C6.984,37.121,4,35.209,4,35.209V17.385    C4,13.865,6.813,11,10.268,11H21v36.689C21,50.094,18.204,53,14.73,53z M52.729,53H42V39h9.456c5.708,0,5.961-2.398,5.961-3.828    c0-1.252-1.125-2.858-3.716-3.213c2.363-0.351,3.146-1.94,3.146-3.197c0-1.433-0.601-3.84-5.961-3.84L42,25v-7.615    C42,13.865,44.811,11,48.27,11H59v35.615C59,50.133,56.189,53,52.729,53z M52,29c0-1.104-0.896-2-2-2h-4v4h4    C51.104,31,52,30.104,52,29z M52.569,35c0-1.104-0.896-2-2-2H46v4h4.569C51.674,37,52.569,36.104,52.569,35z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181599_SVGID_1__focus",
    style: {
      overflow: "visible",
      fill: "#75A2D8"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181599_SVGID_2__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181599_SVGID_1__focus",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1",
    style: {
      clipPath: "url(#5772181599_SVGID_2__focus)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    className: "st3",
    width: 17,
    height: 42,
    style: {
      fill: "#47475E",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21,43.909 2,11 2,53 21,53   ",
    style: {
      fill: "#47475E",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    className: "stshockcolor",
    width: 17,
    height: 42,
    style: {
      fill: "rgb(239, 101, 101)"
    },
    "data-st": "fill:#D06B64;;"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "40,43.909 21,11 21,53 40,53   ",
    style: {
      fill: "#47475E",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 11,
    className: "st0",
    width: 17,
    height: 42,
    style: {
      fill: "#80B34F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59,43.909 40,11 40,53 59,53   ",
    style: {
      fill: "#47475E",
      fillOpacity: 0.3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.3c27bb08377f86bb4bf2824587dccf2c.svg";
export { ForwardRef as ReactComponent };